import Router from "./Router";

const App = () => {
  return (
    <main>
      <Router />
    </main>
  );
};

export default App;
